import { useCallback } from 'react';
import { useRxData } from 'rxdb-hooks';

import { RxdbCollectionName } from '../rxdbCollectionName';
import { getValueFromLocalStorage } from '../share/defaultDoc';
import { ElevationRange, ElevationRangeCollection } from './queryBuilder';

const useElevationRange = () => {
  const getElevationRangeQuery = useCallback(
    (collection: ElevationRangeCollection) =>
      collection?.find({ selector: { fkParentArea: Number(getValueFromLocalStorage('assetId')) } }),
    [],
  );

  const { result: elevationRange } = useRxData<ElevationRange>(
    RxdbCollectionName.ELEVATION_RANGE,
    getElevationRangeQuery,
    { json: true },
  );

  return { elevationRange };
};

export default useElevationRange;
